module.exports = __webpack_public_path__ + "img/照片02.9c81d284.svg";